import React from 'react';

const Certificates = () => {
  const certificates = ['Basic Computing Skills'];

  return (
    <div className="bg-white p-6 rounded-xl shadow">
      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">Certificates Earned</h2>
      {certificates.length ? (
        <ul className="list-disc list-inside text-gray-700">
          {certificates.map((cert, idx) => (
            <li key={idx}>{cert}</li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-600">You haven’t earned any certificates yet.</p>
      )}
    </div>
  );
};

export default Certificates;
